import { useContext } from 'react'

import { PERFORMER_IDS } from '@/constants'
import performerContext from '@/context/performer'
import productionDetailsContext from '@/context/production-details'
import { getMainPerformerId } from '@/utils/production'

export interface IsSuperBowl {
    isSuperBowlPerformer: boolean
    isSuperBowlParkingPerformer: boolean
    isSuperBowlProduction: boolean
    isSuperBowlParkingProduction: boolean
}

export const useIsSuperBowl = (): IsSuperBowl => {
    const { selectors } = useContext(performerContext)
    const { selectors: productionSelectors } = useContext(productionDetailsContext)
    const { SUPERBOWL: SUPERBOWL_ID, SUPERBOWL_PARKING: SUPERBOWL_PARKING_ID } = PERFORMER_IDS

    const performerId = selectors[0]?.id || undefined

    const isSuperBowlPerformer = !!performerId && performerId === SUPERBOWL_ID
    const isSuperBowlParkingPerformer = !!performerId && performerId === SUPERBOWL_PARKING_ID

    let isSuperBowlProduction = false
    let isSuperBowlParkingProduction = false

    if (!productionSelectors?.productionDetails)
        return {
            isSuperBowlPerformer,
            isSuperBowlParkingPerformer,
            isSuperBowlProduction,
            isSuperBowlParkingProduction,
        }

    const mainPerformerId = getMainPerformerId(productionSelectors.productionDetails)
    isSuperBowlProduction = mainPerformerId === SUPERBOWL_ID
    isSuperBowlParkingProduction = mainPerformerId === SUPERBOWL_PARKING_ID

    return { isSuperBowlPerformer, isSuperBowlParkingPerformer, isSuperBowlProduction, isSuperBowlParkingProduction }
}
